import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { LegacyBaseApiService } from '@smartera/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class ElasticSearchIndexService extends LegacyBaseApiService<any> {
	override get apiUrl(): string {
		return Urls.BASE_URL.toString() + '/analytic/report/indexes';
	}

	public getIndexes(): Observable<ESIndex[]> {
		console.log('Method - getIndexes');

		return this._restClientService
			.post(this.apiUrl + '/search?size=200', JSON.stringify({ valid: true }))
			.pipe(map((result) => result.content));
	}

	public getFields(indexId: string, query: string = ''): Observable<ESIndexField[]> {
		return this._restClientService
			.get(this.apiUrl + `/${indexId}/fields?size=1000&query=${query}`)
			.pipe(map((result) => result.content));
	}
}

export interface ESIndex {
	name: string;
	description: string;
	metaData: { data: any };
	id: string;
	generalSettings: { data: string };
	valid: string;
}

export interface ESIndexField {
	indexId: string;
	indexName: string;
	id: string;
	name: string;
	distinctCount: number;
	distinctValues: DistinctValue[];
	dataSegment: IndexFieldDataSegment;
	dataType: IndexFieldDataType;
}

export interface DistinctValue {
	data: string;
	count: number;
	rate: number;
}

export enum IndexFieldDataSegment {
	A = 'A',
	B = 'B',
	C = 'C',
	D = 'D',
	E = 'E',
}

export enum IndexFieldDataType {
	T_BOOLEAN = 'T_BOOLEAN',
	T_BYTE = 'T_BYTE',
	T_DATE = 'T_DATE',
	T_DOUBLE = 'T_DOUBLE',
	T_FLOAT = 'T_FLOAT',
	T_INTEGER = 'T_INTEGER',
	T_LONG = 'T_LONG',
	T_NESTED = 'T_NESTED',
	T_SHORT = 'T_SHORT',
	T_TEXT = 'T_TEXT',
}
